import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/HMFhCnAAnTm2sjRP7"
            >
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Sahali Tongdak Korean Chicken"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/HMFhCnAAnTm2sjRP7"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Sahali Tongdak Korean Chicken"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
